import { buildRouteHelper } from '@blocs.router';
import { appRoutes } from './index';

// Lazy proxy: `routes/index.tsx` and components imported by it transitively
// import this helper, so eager construction at module load would dereference
// `appRoutes` before its initializer has run. The proxy defers `buildRouteHelper`
// to the first property access, after both modules have finished evaluating.
//
// Feature navigation still uses the deprecated `utils/routeHelper`, which also
// builds query strings. This helper is derived from `appRoutes` so path changes
// fail `routeHelper.test.ts`. Query-string support will be added here separately.
type Helper = ReturnType<typeof buildRouteHelper<typeof appRoutes>>;
let cached: Helper | null = null;
const getHelper = (): Helper => {
  if (!cached) cached = buildRouteHelper({ routeDefs: appRoutes });
  return cached;
};

const routeHelper = new Proxy({} as Helper, {
  get: (_target, prop) => getHelper()[prop as keyof Helper],
  has: (_target, prop) => prop in getHelper(),
  ownKeys: () => Reflect.ownKeys(getHelper()),
  getOwnPropertyDescriptor: (_target, prop) => Object.getOwnPropertyDescriptor(getHelper(), prop),
});

export default routeHelper;
